import { Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IOfferGalleryProps {
  images: string[];
}

export const OfferGallery: React.FC<IOfferGalleryProps> = ({ images }) => {
  return (
    <div className={styles['scroll']}>
      {images.map(url => (
        <div key={url} className={styles['image']}>
          <div className={styles['image-inner']}>
            <Image src={url} alt="" objectFit={'cover'} preloader />
          </div>
        </div>
      ))}
    </div>
  );
};
